import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {PortalPageObj} from 'mx-core';

@Injectable({
    providedIn: 'root'
})
export class PrlPagesService {

    private pagesMap = new Map<string, boolean>();
    private pagesLoaded$ = new BehaviorSubject<boolean>(false);

    constructor(private http: HttpClient) {}

    loadPages(): Observable<boolean> {
        return this.http.get<PortalPageObj[]>('/rest/data/pages').pipe(
            map(response => response),
            tap(pages => {
                this.pagesMap.clear();
                pages.forEach(page => this.pagesMap.set(page.name, page.enabled));
                this.pagesLoaded$.next(true);
            }),
            map(() => true)
        );
    }

    ensurePagesLoaded(): Observable<boolean> {
        if (this.pagesLoaded$.value) {
            return of(true);
        }
        return this.loadPages();
    }

    isPageEnabled(pageName: string): boolean {
        if (!this.pagesLoaded$.value) {
            return false;
        }
        return this.pagesMap.get(pageName) ?? true;
    }

    get pagesLoaded(): Observable<boolean> {
        return this.pagesLoaded$.asObservable();
    }
}